import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-dunslough.webp"
            alt="Dunslough"
          />
        </p>
        <strong>
          A labor camp served by convicts and a ghetto for the destitute poor.
        </strong>{" "}
        <em>
          Dunslough is a ghetto for the destitute poor of the city, as well as
          the site of Ironhook Prison and its labor camp. Originally, the ghetto
          was a neighborhood for families of prisoners, but over the years,
          extreme poverty and neglect have worn it down into a sodden ruin. A
          vicious cycle plays out here: crime driven by desperation, then
          arrest, incarceration, and release back to Dunslough—giving Ironhook
          an endless supply of laborers to exploit.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-six-dunslough.webp"
          alt="Dunslough"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Scene:</strong> Mud-covered laborers returning from the
                Mire. Destitute families scrounging for scraps along the roadway
                to the Barrowcleft farms. Bored Ironhook guards, rifles slung on
                their backs, watching a taskmaster lash a labor camp prisoner.
                <br />
                <strong>Streets:</strong> Cramped, multi-level—some of stone but
                many of dirt, sodden into thick black mud. No street names to be
                found.
                <br />
                <strong>Buildings:</strong> Decrepit wooden row houses, many
                abandoned from fire damage or fallen-in from age. Stone silos,
                clanking steam machinery, and metal sheds for dredging
                equipment.
                <br />
                <strong>Factions:</strong>
                <ul>
                  <li>1. The Lost</li>
                  <li>2. The Silver Nails</li>
                  <li>3. Ironhook Prison</li>
                  <li>4. Ministry of Perservation</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-dunslough.webp"
                  alt="Dunslough district traits"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Dunslough Locations</h1>
        <strong>
          <u>Dunslough Ghetto</u>
        </strong>
        : The most destitute of the city end up in Dunslough, working the Mire
        for a pittance just to buy their daily bread. The city counts the space
        as “runoff” for the prison grounds, and does nothing to maintain it.
        <br />
        <br />
        <strong>
          <u>Dunvil Labor Camp</u>
        </strong>
        : Poor prisoners who can’t afford to bribe the staff at Ironhook spend
        most of their days toiling at Dunvil Labor Camp, loading precious ores
        onto barges for the rail station and breaking the larger rocks hauled
        from the Mire.
        <br />
        <br />
        <strong>
          <u>Ironhook Prison</u>
        </strong>
        : A towering metal fortress, where the worst (or most unlucky) criminals
        are incarcerated. The poorest are forced to work at Dunvil Labor Camp.
        The most well-connected prisoners manage a comfortable stay, and may
        even continue to run their criminal enterprises from behind bars.
        <br />
        <br />
        <strong>
          <u>The Mire</u>
        </strong>
        : A massive mud-quarry pit, the Mire is the site of the impact of an
        ancient celestial body, which left behind a variety of precious ores and
        jewels embedded in the earth.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Dunslough = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <div
                    class="bitdFont morkBorgText"
                    style={{ textAlign: "center" }}
                  >
                    💀{" "}
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-introduction"
                    >
                      Introduction
                    </a>{" "}
                    💀
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-districts"
                    >
                      Districts
                    </a>{" "}
                    💀
                  </div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Dunslough;
